"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _toHtml = _interopRequireDefault(require("./toHtml.js"));
var _html = _interopRequireDefault(require("./html.css"));
var _ReadHtml = _interopRequireDefault(require("./ReadHtml"));
var _htmlReactParser = _interopRequireWildcard(require("html-react-parser"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Html = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Html, _React$Component);
  function Html() {
    var _this;
    _classCallCheck(this, Html);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Html, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "stop", function () {
      if (_this.refs.readhtml) {
        _this.refs.readhtml.stop();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      if (_this.refs.readhtml) {
        _this.refs.readhtml.play();
      } else if (_this.props.onEnded) {
        _this.props.onEnded();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getAction", function () {
      if (_this.refs.readhtml) {
        return _this.refs.readhtml.getAction();
      }
      return null;
    });
    _defineProperty(_assertThisInitialized(_this), "_getAsteriskCode", function () {
      return "<span class=\"".concat(_html["default"].asterisk, "\" title=\"Required field\">&#42</span>");
    });
    _defineProperty(_assertThisInitialized(_this), "_getInformationPlaceholder", function () {
      return " <span class=\"cccisd-wysiwyg-information-placeholder\">!</span>";
    });
    _defineProperty(_assertThisInitialized(_this), "_addAsterisk", function (content) {
      var asteriskCode = _this._getAsteriskCode();
      if (content === '') {
        return content;
      }
      if (content.slice(-4) === '</p>') {
        return content.slice(0, -4) + asteriskCode + '</p>';
      }
      if (content.slice(-6) === '</div>') {
        return content.slice(0, -6) + asteriskCode + '</div>';
      }
      return content + asteriskCode;
    });
    _defineProperty(_assertThisInitialized(_this), "_addInformationPlaceholder", function (content) {
      var informationPlaceholder = _this._getInformationPlaceholder();
      if (content.slice(-4) === '</p>') {
        return content.slice(0, -4) + informationPlaceholder + '</p>';
      }
      if (content.slice(-6) === '</div>') {
        return content.slice(0, -6) + informationPlaceholder + '</div>';
      }
      return content + informationPlaceholder;
    });
    _defineProperty(_assertThisInitialized(_this), "_addPrependText", function (content) {
      var prependText = _this.props.prependWith;
      if (content === '') {
        return content;
      }
      if (/^<[^>]+>/.test(content)) {
        return content.replace(/(>)([\s]*)([^<\s]{1})/, "$1".concat(prependText, "$2$3"));
      }
      return prependText + content;
    });
    _defineProperty(_assertThisInitialized(_this), "_getContent", function () {
      var content = _this.props.content;
      var meta = content.meta || {};
      if (!_this.context.flow) {
        // Replace variables etc.
        content = (0, _toHtml["default"])(content);
      }
      if (!(0, _isString2["default"])(content)) {
        content = content.content;
      }

      // Show asterisk at the end if it's required
      if (_this.props.showRequiredState) {
        content = _this._addAsterisk(content);
      }

      // Add information placeholder
      // It will be replaced later with tooltip
      if (meta.information) {
        content = _this._addInformationPlaceholder(content);
      }

      // Prepend text
      if (_this.props.prependWith) {
        content = _this._addPrependText(content);
      }
      return content;
    });
    _defineProperty(_assertThisInitialized(_this), "_getReactContent", function () {
      var content = _this._getContent();

      // Add tooltips
      var hasTooltips = content.includes(' data-tooltip=');
      var information = (0, _get2["default"])(_this.props, 'content.meta.information.text');
      var html = hasTooltips || information ? (0, _htmlReactParser["default"])(content, {
        replace: function replace(_ref) {
          var attribs = _ref.attribs,
            children = _ref.children,
            name = _ref.name;
          // Add inline tooltips
          if (name === 'span' && attribs['data-tooltip']) {
            var tooltip = (0, _get2["default"])(_this.props, "content.meta.tooltips.".concat(attribs['data-tooltip'], ".text"));
            if (tooltip) {
              return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                title: tooltip
              }, /*#__PURE__*/_react["default"].createElement("span", {
                className: "cccisd-wysiwyg-tooltip"
              }, (0, _htmlReactParser.domToReact)(children)));
            }
          }

          // Add tooltip at the end
          if (name === 'span' && attribs["class"] === 'cccisd-wysiwyg-information-placeholder') {
            return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
              title: information
            }, /*#__PURE__*/_react["default"].createElement(_question["default"], null));
          }
        }
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      });
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: 'clearfix ' + _html["default"].wrapper
      }, html);
    });
    return _this;
  }
  _createClass(Html, [{
    key: "render",
    value: function render() {
      var content = this._getContent();
      var reactContent = this._getReactContent();
      var html;
      if (this.props.content.meta && this.props.content.meta.audio && !this.props.accommodations.disableAudio) {
        html = /*#__PURE__*/_react["default"].createElement(_ReadHtml["default"], {
          ref: "readhtml",
          transcript: content,
          reactContent: reactContent,
          audio: this.props.content.meta.audio,
          accommodations: this.props.accommodations,
          registerAction: this.props.registerAction,
          setParameters: this.props.setParameters,
          onEnded: this.props.onEnded,
          allowMasking: this.props.allowMasking,
          showPlayButton: this.props.showPlayButton,
          clickplay: this.props.clickplay && !this.props.render
        });
      } else {
        html = reactContent;
      }
      if (this.props.render) {
        return this.props.render({
          html: html,
          playAudio: this.play,
          getAction: this.getAction
        });
      }
      return html;
    }
  }]);
  return Html;
}(_react["default"].Component);
_defineProperty(Html, "propTypes", {
  accommodations: _propTypes["default"].object,
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  showRequiredState: _propTypes["default"].bool,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  allowMasking: _propTypes["default"].bool,
  showPlayButton: _propTypes["default"].bool,
  clickplay: _propTypes["default"].bool,
  prependWith: _propTypes["default"].node,
  render: _propTypes["default"].func
});
_defineProperty(Html, "defaultProps", {
  // Example accomodations: {highlight:true, autoplayQuestions: true, autoplayChoices: true, masking:false}
  accommodations: {},
  // Html content
  content: '',
  // Show red asterisk at the end or not?
  showRequiredState: false,
  // Does this WYSIWYG allow masking if accommodations has it enabled?
  // Generally only answer text will have allowMasking enabled
  allowMasking: false,
  showPlayButton: false,
  clickplay: true
});
_defineProperty(Html, "contextTypes", {
  flow: _propTypes["default"].object
});